import '@lottiefiles/lottie-player';
import Grid from './modules/Grid';
import './modules/comp';
import './modules/mybarba';
import { tt__init } from './modules/custom';

jQuery(function () {        
      tt__init();       
});
